import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { captureAttribution } from '../lib/attribution'
import { isPublicMeasurementPath, measurementEnabled, trackPage } from '../lib/measurement'
import { CookieConsent } from './CookieConsent'

export function SiteMeasurement() {
  const { pathname, search } = useLocation()
  const publicPage = isPublicMeasurementPath(pathname)
  useEffect(() => {
    if (publicPage) captureAttribution(search)
    trackPage(pathname, search)
  }, [pathname, search, publicPage])
  return <><Outlet />{publicPage && measurementEnabled && <CookieConsent />}</>
}
